import Stack from "@mui/material/Stack";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { PaperChart } from "../../components/PaperChart";
import { useDialogConfirmation } from "../../hooks/useDialogConfirmation";
import { isEmpty } from "lodash";
import { Maps } from "../../components/Maps";
import WithoutInformation from "./WithoutInformation";

type MapsViewProps = {
  clients: any[];
  loadingClient?: boolean;
};

function MapsView({ loadingClient, clients }: MapsViewProps) {
  const navigate = useNavigate();
  const dialog = useDialogConfirmation();

  const handleNavigateToPerson = useCallback(
    (item) => {
      dialog.show(item?.nome, "Deseja visitar o perfil desse cliente ?", {
        onConfirmate: () => {
          navigate(`people/${item.id_pessoa}`, { state: item });
          dialog.close();
        },
      });
    },
    [dialog, navigate]
  );

  return (
    <>
      <Stack spacing={4}>
        <PaperChart loading={loadingClient} variant="outlined" elevation={0}>
          {!isEmpty(clients) ? (
            <Maps
              style={{ height: "100vh" }}
              data={clients}
              onClick={handleNavigateToPerson}
            />
          ) : (
            <WithoutInformation />
          )}
        </PaperChart>
      </Stack>
    </>
  );
}

export default MapsView;
